module.exports = __webpack_public_path__ + "img/henrik.b87c4931.png";